export const verify = {
    title: 'メールアドレスの変更',
    email: 'メールの確認中',
    noParamsError: '必要なパラメータがありません (verificationId または verificationToken)',
    inProgress: 'メールアドレスの更新処理中です。',
    successChangeEmail: 'メールアドレスの変更が成功しました。トップページにリダイレクトします。',
    loginPage: 'ログイン',
    oldEmail: '古いメールアドレス',
    newEmail: '新しいメールアドレス'
}
